<template>
    <div v-if="isVisible" class="form-item select"
        :class="[item.data.htmloptions, isInvalid ? 'is-invalid' : '', {'disabled' : item.data.disabled }]"
        v-click-outside="{
            exclude: [],
            handler: onClickOutside
        }"
    >

        <div :class="['select__wrapper', {'float-label' : floatLabel }]">
            <button type="button" class="select" @click="toggleOptions">
                <span> {{ selectedOption.label }}</span>
            </button>

            <div v-if="showOptions" class="select__options">
                <ul>
                    <li v-for="answer in answerOptions" :key="answer.id" @click="setOption(answer)">
                        {{ answer.label }}
                    </li>
                </ul>
            </div>

            <i class="icon-form-arrow"></i>
        </div>

        <Label :item="item" :is-invalid="isInvalid" :error-message="errorMessage" />

        <input type="hidden" v-model="selectedOption.value" :name="item.data.id"/>
    </div>
</template>

<script>
import Label from "../components/Label.vue";
import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";
import clickOutside from '../util/clickOutside';


export default {
    name: 'Select',
    components: { Label },
    mixins: [ errorMixin, logicMixin ],
    directives: {
        clickOutside
    },
    props: {
        item: {
            type: Object
        },
        formValues: {
            type: Object
        },
        value: {
            type: [String, Number],
            default: ''
        },
    },
    data: function() {
        return {
            selectedOption: '',
            showOptions: false
        };
    },
    computed: {
        floatLabel() {
            if(this.showOptions || Object.keys(this.selectedOption).length !== 0) {
                return true;
            }
        },
        answerOptions() {
            const answeroptions = this.item.data.answeroptions;

            if(this.item.data.alphabeticalorder) {
                return answeroptions.sort((a, b) => {
                    if (a.label < b.label) {
                        return -1;
                    }
                    if ( a.label > b.label) {
                        return 1;
                    }
                    return 0;
                });
            }

            return answeroptions;
        },
        internalValue: {
            get () {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    mounted() {
        let prefilledValue

        if (Object.keys(this.formValues).length) {

            prefilledValue = this.formValues[this.item.data.uniqlabel]

        } else {
            prefilledValue = this.internalValue
        }

        let selectedOption
        if (prefilledValue) {
            selectedOption = this.answerOptions.find(answer => answer.value === prefilledValue)
        }

        if (!selectedOption) {
            selectedOption = this.answerOptions.find(answer => answer.is_default)
        }
        if (selectedOption) {
            this.internalValue = selectedOption.value
            this.selectedOption = selectedOption
        } else {
            this.selectedOption = {}
            this.internalValue = ''
        }

        //this.selectedOption = {}
    },
    methods: {
        setOption(answer) {
            this.selectedOption = answer;
            this.showOptions = false;
            this.internalValue = answer.value
            this.$emit('update-form-value', this.item.data.uniqlabel, answer.value)
        },
        toggleOptions() {
            if (this.item.data.disabled) {
                return
            }

            this.showOptions = !this.showOptions;
        },
        onClickOutside() {
            this.showOptions = false;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "frontend/styles/framework";


</style>